module.exports = __webpack_public_path__ + "static/media/alliedGlobal-01.144ebd4a.png";